import React from 'react';

const ENSGuide = () => {
  return (
    <div className="help-section">
      <div className="section-header">
        <div className="icon">🎯</div>
        <h2>ENS Suite Guide</h2>
      </div>
      
      <div className="info-card">
        <h3>.zpost.eth Domains Only</h3>
        <p>The Zpost ecosystem exclusively supports .zpost.eth domains. This creates a verified, curated community.</p>
      </div>
      
      <div className="section-grid">
        <div className="info-card">
          <h3>Minting Process</h3>
          <ol style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Access ENS App via left sidebar</li>
            <li>Connect your Zwallet</li>
            <li>Enter desired subdomain (3-63 chars)</li>
            <li>Confirm transaction</li>
            <li>Wait for confirmation</li>
          </ol>
        </div>
        
        <div className="info-card">
          <h3>Primary Name Setup</h3>
          <ol style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Open Identity App dashboard</li>
            <li>Navigate to "Primary Name" tab</li>
            <li>Select your .zpost.eth domain</li>
            <li>Click "Set as Primary Name"</li>
            <li>Confirm transaction</li>
          </ol>
        </div>
      </div>
      
      <div className="success-box">
        <h4><span>✅</span> Benefits</h4>
        <p style={{ color: 'var(--text-light)', margin: 0 }}>
          Your .zpost.eth domain is your universal Web3 identity. You own it completely and can transfer or sell it.
        </p>
      </div>
    </div>
  );
};

export default ENSGuide;
